// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DdjDocument } from '@interfaces/document.interfaces';

@Component({
    selector: 'sso-success-video-modal',
    templateUrl: './sso-success-video-modal.component.html',
    styleUrls: ['./sso-success-video-modal.component.scss'],
})
export class SSOSuccessVideoModalComponent {
    constructor(
        private dialogRef: MatDialogRef<SSOSuccessVideoModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { videoTitle: string; videoSource: string }
    ) {}

    close() {
        this.dialogRef.close();
    }
}
